import store from '@/store/index.js'
import riaApiClient from "@/api";
import { DateTime } from "luxon";
import { isActiveProduct } from "@/helpers/productsHelpers";

const version = process.env.VUE_APP_API_VERSION;
const timeSet = {hour: 23, minute: 59, second: 59};
const timeSetStartDay = {hour: 0, minute: 0, second: 0};

export default {
  namespaced: true,
  state: {
    _environment: null,
    _resort: null,
    _resorts: {},
    _selectedCatalog: null,
    _selectedProduct: null,
    _scheme: null,
  },
  getters: {
    environment: state => state._environment,
    environment_id: state => state._environment.id,
    environment_name: state => state._environment.name,
    environment_analytics: state => state._environment.analytics,
    analytics: state => state._environment.analytics,
    resort: state => state._resort,
    resorts: state => state._environment.resorts.sort((newVal, oldVal) => newVal.name.localeCompare(oldVal.name)),
    catalogs: state => state._resort.catalogs,
    catalogsWithActiveProducts: state => {
      return state._resort.catalogs
        .filter(catalog =>
          catalog.active &&
          DateTime.fromSQL(catalog.from_date).set(timeSetStartDay).toMillis() < DateTime.local().toMillis() &&
          DateTime.fromSQL(catalog.to_date).set(timeSet).toMillis() > DateTime.local().toMillis() &&
          catalog.products
            .some(product => isActiveProduct(product))
        )
    },
    selectedCatalog: state => state._selectedCatalog,
    allProducts: (state, getters) => {
      let products = []
      getters.catalogsWithActiveProducts
        .forEach(catalog => { catalog.products.forEach( product => { products.push(product) }) })
      return products
    },
    products: state => state._selectedCatalog.products,
    selectedProduct: state => state._selectedProduct,
    scheme: state => state._environment.scheme,
    currency: state => state._resort.currency,
    webVersion: state => state._resort.config.find(web => web.name === 'isWebEnabled').value !== '0',
    appVersion: state => state._resort.config.find(web => web.name === 'isAppEnabled').value !== '0',
    platformUnavailable: (state, getters) => {
      return !getters.webVersion && store.getters['device/platform'] === 'BROWSER'||
      !getters.appVersion && store.getters['device/platform'] !== 'BROWSER'
    },
    participantById: state => id => state._selectedCatalog.participants.find(participant => participant.id == id)
  },
  actions: {
    async loadResort(context, payload) {
      const response = await riaApiClient.get(`/api/${version}/resorts/${payload.id}`);
      context.commit("SET_RESORT", response.data);
    },
    async loadResorts(context, payload) {
      const response = await riaApiClient.get(`/api/${version}/environments`, {
        params: payload
      });
      context.commit("SET_ENVIRONMENT", response.data.data[0]);
    },
    selectCatalogAndProduct(context, payload) {
      context.commit("SET_SELECTED_CATALOG", { id: payload.catalogId });
      context.commit("SET_SELECTED_PRODUCT", { id: payload.productId });
    },
    resetResort(context) {
      context.commit("SET_RESORT", null);
    },
    resetCatalogAndProduct(context) {
      context.commit("SET_SELECTED_CATALOG", null);
      context.commit("SET_SELECTED_PRODUCT", null);
    },
  },
  mutations: {
    SET_ENVIRONMENT(state, payload){
      state._environment = payload
    },
    SET_RESORT(state, payload) {
      state._resort = payload;
    },
    SET_CATALOGS(state, payload) {
      state._catalogs = payload;
    },
    SET_SELECTED_CATALOG(state, payload) {
      state._selectedCatalog = payload ? state._resort.catalogs.find(catalog => catalog.id === payload.id) : null;
    },
    SET_SELECTED_PRODUCT(state, payload) {
      state._selectedProduct = payload ? state._selectedCatalog.products.find(product => product.id === payload.id) : null;
    }
  }
};
